import { render } from "./vshoppluswecomedit.vue?vue&type=template&id=0b2315b5&scoped=true"
import script from "./vshoppluswecomedit.vue?vue&type=script&lang=js"
export * from "./vshoppluswecomedit.vue?vue&type=script&lang=js"

import "./vshoppluswecomedit.vue?vue&type=style&index=0&id=0b2315b5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2315b5"]])

export default __exports__